<template>
  <div class="basicssetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>安全配置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">


      <div class="main">
        <h4>密码机制</h4>
        <div class="upbg">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row >
              <el-col :span="12">
                <el-form-item label="内部用户:"
                              prop="userTitle">
                  <el-radio-group v-model="ruleForm.insideLoginConfig"
                                  :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  size="medium">
                    <el-radio-button label="strong">强密码</el-radio-button>
                    <el-radio-button label="weak">弱密码</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="外部用户:"
                              prop="userTitle">
                  <el-radio-group v-model="ruleForm.outsideLoginConfig"
                                  :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  size="medium">
                    <el-radio-button label="strong">强密码</el-radio-button>
                    <el-radio-button label="weak">弱密码</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div>


      <div class="main">
        <h4>探针配置</h4>
        <div class="upbg">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row >
              <el-col :span="12">
                <el-form-item label="探针开关:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleForm.probeTokenMode">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleForm.probeTokenMode === '1'" :span="12">
                <el-form-item label="探针令牌:"
                              prop="userTitle">
                  <el-input v-model="ruleForm.probeToken"
                            placeholder="请填写探针令牌"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div>




      <div class="main">
        <h4>安全配置</h4>
        <div class="upbg">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row>
              <el-col :span="24"
                      style="margin-right:10px;">
                <el-form-item label="敏感词模式:"
                              prop="userTitle">
                  <el-radio-group v-model="ruleForm.sensitiveWordsMode"
                                  :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  size="medium">
                    <el-radio-button label="off">不开启</el-radio-button>
                    <el-radio-button label="replace">星号替换</el-radio-button>
                    <el-radio-button label="filter">过滤</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24"
                      style="margin-right:10px;margin-bottom:30px;">

                <el-form-item label="敏感词清单:"
                              prop="userTitle">
                  <el-input v-model="ruleForm.sensitiveWords"
                            style="width:100%;height:560px;"
                            placeholder="请填写敏感词清单"
                            type="textarea"></el-input>

                  <p @click="importSensitive"
                     :style="isSimple?'display:inline;font-size:14px;color:#fd9112;text-decoration:underline;cursor:pointer;':'display:inline;font-size:14px;color:#185ED3;text-decoration:underline;cursor:pointer;'">导入自带过滤词</p>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

          <!-- <div class="main"
              style="padding-top:0px;"
              v-if="ruleForm.sensitiveWordsMode !== 'off'">
            <p>敏感词清单</p>
            <div class="upbg"
                style="padding:0px;height:300px;">
              <el-input v-model="ruleForm.sensitiveWords"
                        style="width:100%;height:100%;"
                        placeholder="请填写敏感词清单"
                                type="textarea"></el-input>
            </div>
          </div> -->
        </div>
      </div>

      

      <!-- <div class="main"
           style="padding-top:0px;"
           v-if="ruleForm.sensitiveWordsMode !== 'off'">
        <h4>敏感词清单</h4>
        <div class="upbg"
             style="padding:0px;height:300px;">
          <el-input v-model="ruleForm.sensitiveWords"
                    style="width:100%;height:100%;"
                    placeholder="请填写敏感词清单"
                            type="textarea"></el-input>
        </div>
      </div> -->

    </div>

    <div class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import E from "wangeditor";
import getMD5 from "@/plugins/getMD5";
import SparkMD5 from "spark-md5";
import { picPrefix } from "@/constants/piccommon";
import { setAppSecurityConfig, getAppSecurityConfig } from "@/api/config";
export default {
  components: {

  },
  data () {
    return {
      picPrefix,

      reg: '',
      auth: '',
      ruleFormPTFlag: false,
      ruleForm: {
        sensitiveWordsMode: 'off',
        sensitiveWords: '',
        insideLoginConfig:'weak',
        outsideLoginConfig:'weak',
        probeToken:'',
        probeTokenMode:'0'
      },

      rules: {
        sensitiveWordsMode: [
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
      },

      //网站徽标
      logoFile: null,


      isRefresh: false
    };
  },
  methods: {


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.getAppSecurityConfigAsync();
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },


    closeForm () {
      this.$message('正在开发中……')
    },

    importSensitive () {
      this.$message('正在开发中……')
    },




    submitForm () {
      // console.log(this.phoneEditorReg.txt.html())
      if (this.ruleForm.sensitiveWordsMode !== 'off') {
        if (
          this.ruleForm.sensitiveWordsMode &&
          this.ruleForm.sensitiveWords
        ) {
          let data = {
            sensitiveWordsMode: this.ruleForm.sensitiveWordsMode,
            sensitiveWords: this.ruleForm.sensitiveWords,
            insideLoginConfig: this.ruleForm.insideLoginConfig,
            outsideLoginConfig: this.ruleForm.outsideLoginConfig,
            probeToken:this.ruleForm.probeToken,
            probeTokenMode: this.ruleForm.probeTokenMode
          }
          this.setAppSecurityConfigAsync(data)
        } else {
          this.$message.error('请全部填写！')
        }
      } else {
        let data = {
          sensitiveWordsMode: this.ruleForm.sensitiveWordsMode,
          sensitiveWords: '请填写敏感词清单',
          insideLoginConfig: this.ruleForm.insideLoginConfig,
          outsideLoginConfig: this.ruleForm.outsideLoginConfig,
          probeToken:this.ruleForm.probeToken,
          probeTokenMode: this.ruleForm.probeTokenMode
        }
        this.setAppSecurityConfigAsync(data)
      }





    },





    //获取配置
    async getAppSecurityConfigAsync () {
      this.isRefresh = true
      let { status, data, message, errors } = await getAppSecurityConfig();
      if (status) {
        if (data.sensitiveWords) {
          this.ruleForm.sensitiveWords = data.sensitiveWords
        }
        if (data.sensitiveWordsMode) {
          this.ruleForm.sensitiveWordsMode = data.sensitiveWordsMode
        }

        if (data.insideLoginConfig) {
          this.ruleForm.insideLoginConfig = data.insideLoginConfig
        }

        if (data.outsideLoginConfig) {
          this.ruleForm.outsideLoginConfig = data.outsideLoginConfig
        }
        if(data.probeTokenMode){
          this.ruleForm.probeTokenMode = data.probeTokenMode
        }
        if(data.probeToken){
          this.ruleForm.probeToken = data.probeToken
        }


        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    //设置配置
    async setAppSecurityConfigAsync (val) {
      let { status, data, message, errors } = await setAppSecurityConfig(val);
      if (status) {
        this.$message.success('设置成功！');
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    this.getAppSecurityConfigAsync()
  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./safemanage.scss";

h4 {
  font-size: 18px;
}
.basicssetup {
  position: relative;
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0px;
  right: 2px;
  // top: 0;
  z-index: 5;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn /deep/ .el-button--primary {
  background-color: #185ed3;
}
/deep/ .el-form-item__label {
  font-weight: 600;
}

/deep/ .el-loading-mask {
  z-index: 2;
}
/deep/ .el-icon-circle-close {
  margin-top: 150px;
}

.el-form /deep/ textarea::-webkit-scrollbar {
  width: 8px;
  height: 32px;
}
.el-form /deep/ textarea::-webkit-scrollbar-thumb {
  border-radius: 3px;
  height: 38px;
  /* 滚动条滑块长度 */
  background: rgba(24, 94, 212, 0.2);
}
</style>
